export default {
  init() {
    // JavaScript to be fired on all pages



  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired


    /* eslint-disable */
    (function($){

      $.fn.shuffleLetters = function(prop){


        return this.each(function(){
          $.fn.shuffleLetters = function(prop){

            var options = $.extend({
              "step"  : 4,    // How many times should the letters be changed
              "fps"   : 12,   // Frames Per Second
              "text"  : ""    // Use this text instead of the contents
            },prop)

            return this.each(function(){

              var el = $(this),
                str = "";

              if(options.text) {
                str = options.text.split('');
              }
              else {
                str = el.text().split('');
              }

              // The types array holds the type for each character;
              // Letters holds the positions of non-space characters;

              var types = [],
                letters = [];

              // Looping through all the chars of the string

              for(var i=0;i<str.length;i++){

                var ch = str[i];

                if(ch == " "){
                  types[i] = "space";
                  continue;
                }
                else if(/[a-z]/.test(ch)){
                  types[i] = "lowerLetter";
                }
                else if(/[A-Z]/.test(ch)){
                  types[i] = "upperLetter";
                }
                else {
                  types[i] = "symbol";
                }

                letters.push(i);
              }

              el.html("");

              // Self executing named function expression:

              (function shuffle(start){

                // This code is run options.fps times per second
                // and updates the contents of the page element

                var i,
                  len = letters.length,
                  strCopy = str.slice(0); // Fresh copy of the string

                if(start>len){
                  return;
                }

                // All the work gets done here
                for(i=Math.max(start,0); i < len; i++){

                  // The start argument and options.step limit
                  // the characters we will be working on at once

                  if( i < start+options.step){
                    // Generate a random character at this position
                    strCopy[letters[i]] = randomChar(types[letters[i]]);
                  }
                  else {
                    strCopy[letters[i]] = "";
                  }
                }

                el.text(strCopy.join(""));

                setTimeout(function(){

                  shuffle(start+1);

                },1000/options.fps);

              })(-options.step);

            });
          };
        });
      };

      // A helper function

      function randomChar(type){
        var pool = "";

        if (type == "lowerLetter"){
          pool = "abcdefghijklmnopqrstuvwxyz0123456789";
        }
        else if (type == "upperLetter"){
          pool = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        }
        else if (type == "symbol"){
          pool = ",.?/\\(^)![]{}*&^%$#'\"";
        }

        var arr = pool.split('');
        return arr[Math.floor(Math.random()*arr.length)];
      }

    })(jQuery);


    function getRandomColor() {
      for (var t = "#", e = 0; e < 6; e++) t += "0123456789ABCDEF"[Math.floor(16 * Math.random())];
      return t;
    }

    function randomInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function initGlitches(n) {
      var animationInterval = setInterval(function() {
      var t = randomInteger(100, 300),
        e = randomInteger(0, 40),
        o = randomInteger(500, 4000),
        a = t + e,
        u = "rect(" + t + "px, " + o + "px, " + a + "px, " + 0.02 * (o + a) + "px)",
        l = 20 * Math.random() - 10,
        A = 540 * Math.random() - 10;


        $('.glitch__image').css({
          clip: u,
          left: l,
          top: A,
          color: getRandomColor(),
          opacity: 1,
          display: "block",
          backgroundColor: getRandomColor()
        });
      }, 100);

      setTimeout(function(){
        clearInterval(animationInterval);
        $('.glitch__image').fadeOut();
        $('.glitch-transition').fadeOut();
      }, 400)



    }

    /* eslint-enable */

    setTimeout(function(){
        initGlitches(99999);
    }, 260);

    $('a').not('.primary-navigation .has-submenu > a').click(function(){
      initGlitches(99999);
      setTimeout(function(){
        return true;
      }, 600);
    });

    $('.nav-callout a').addClass('nav-module-link');

    $('.primary-navigation .has-submenu > a').click(function(e){

      if( $(e.target).closest('.nav-module-link').length > 0) {
        initGlitches(99999);
        setTimeout(function(){
          return true;
        }, 600);


      } else {


        e.preventDefault();
        var subNavId = null;

        $(this).closest('.menu-item').each(function () {
          var classes = this.className.split(/\s+/);

          $.each(classes, function (i, name) {
            if (name.indexOf('submenu-') === 0) {
              subNavId = name;
            }
          });
        });


        if ($(this).closest('li.menu-item').hasClass('active')) {
          $(this).closest('li.menu-item').removeClass('active');
        } else {
          $('.primary-navigation li.active').removeClass('active');
          $(this).closest('li.menu-item').addClass('active');
        }


        // console.log('.sub-nav-holder #' + subNavId);
        // $('.' + subNavId).addClass('active-sub-nav').show();

        if ($('#' + subNavId).hasClass('active-sub-nav')) {
          $('#' + subNavId).removeClass('active-sub-nav').hide();
        } else {
          $('.active-sub-nav').removeClass('active-sub-nav').hide();
          $('#' + subNavId).addClass('active-sub-nav').show();

        }

        if ($('.sub-nav-holder #' + subNavId).hasClass('subnav-simple') && $('.sub-nav-holder #' + subNavId).hasClass('active-sub-nav')) {
          $('.sub-nav-holder #' + subNavId).appendTo($(this));
        }

      }


    });

    $('body').addClass('redselection');

    $(document).click(function(e){

      // skip if click was on a tab button
      if ($(e.target).closest('.tab-button').length > 0) {
        return true;
      }

      if ($('body').hasClass('redselection')) {
        $('body').removeClass('redselection').addClass('greenselection');
      } else if ($('body').hasClass('greenselection')) {
        $('body').removeClass('greenselection').addClass('blueselection');
      } else if ($('body').hasClass('blueselection')) {
        $('body').removeClass('blueselection').addClass('redselection');
      }



      // console.log($(e.target).closest('.subnav-simple .nav-module-link').length);


      // Check if click was triggered on or within #menu_content
      if( $(e.target).closest('.subnav-simple .nav-module-link').length > 0 || $(e.target).closest('.primary-navigation li > a').length > 0) {
        return true;
      } else {
        $('.primary-navigation li.active').removeClass('active');
        $('.active-sub-nav').removeClass('active-sub-nav').hide();
        $('.primary-navigation .menu-item-has-children').removeClass('is-active');
        $('.primary-navigation .sub-menu').removeClass('active-sub-menu');

      }



    });

    /*
    * Scroll fade colors
     */

    $(window).scroll(function() {

      // selectors
      var $window = $(window),
        $body = $('body'),
        $panel = $('.panel:visible, div[class^=\'module-\']:visible, .type-project:visible');

      // Change 33% earlier than scroll position so colour is there when you arrive.
      var scroll = $window.scrollTop() + ($window.height() / 2);

      $panel.each(function () {
        var $this = $(this);

        // if position is within range of this panel.
        // So position of (position of top of div <= scroll position) && (position of bottom of div > scroll position).
        // Remember we set the scroll to 33% earlier in scroll var.

        if($window.scrollTop() === 0){
          $body.removeClass('bg-white');
          $body.addClass('bg-black');
        } else if ($this.position().top <= scroll && $this.position().top + $this.height() > scroll) {

          // Remove all classes on body with color-
          $body.removeClass(function (index, css) {
            return (css.match (/(^|\s)bg-\S+/g) || []).join(' ');
          });

          // Add class of currently active div
          $body.addClass('bg-' + $(this).data('color'));
        }




      });

    }).scroll();

    $(window).load(function() {

      // selectors
      var $body = $('body'),
        $panel = $('.panel, div[class^=\'module-\'], .type-project');

      // Change 33% earlier than scroll position so colour is there when you arrive.


      $panel.each(function () {
        var $this = $(this);

        // console.log($this.position().top);

        // if position is within range of this panel.
        // So position of (position of top of div <= scroll position) && (position of bottom of div > scroll position).
        // Remember we set the scroll to 33% earlier in scroll var.
        if ($this.position().top >= 200) {

          // Remove all classes on body with color-
          $body.removeClass(function (index, css) {
            return (css.match (/(^|\s)bg-\S+/g) || []).join(' ');
          });

          // Add class of currently active div
          $body.addClass('bg-' + $(this).data('color'));
        }
      });

    }).load();

    /**
     * Get videos on load
     */
    (function () {
      getVideos();
    })();

    /**
     * For each video player, create custom thumbnail or
     * use Youtube max resolution default thumbnail and create
     * iframe video.
     */
    function getVideos() {
      var v = document.getElementsByClassName('youtube-player');
      for (var n = 0; n < v.length; n++) {
        var p = document.createElement('div');


        var placeholder = v[n].hasAttribute('data-thumbnail')
          ? v[n].getAttribute('data-thumbnail')
          : '';

        if (placeholder.length) p.innerHTML = createCustomThumbail(placeholder);


        v[n].appendChild(p);
        p.addEventListener('click', function () {
          var parent = this.parentNode;
          createIframe(parent, parent.getAttribute('data-id'));
        });
      }
    }

    /**
     * Create custom thumbnail from data-attribute provided url
     * @param {string} url
     * @return {string} The HTML containing the <img> tag
     */
    function createCustomThumbail(url) {
      return (
        '<div class="youtube-thumbnail" style="background-image:url(' +
        url +
        ');" ><div class="youtube-play-btn"></div>'
      );
    }



    /**
     * Create and load iframe in Youtube container
     **/
    function createIframe(v, id) {
      var iframe = document.createElement('iframe');
      // console.log(v);
      iframe.setAttribute(
        'src',
        '//www.youtube.com/embed/' +
        id +
        '?autoplay=1&color=white&autohide=2&modestbranding=1&border=0&wmode=opaque&enablejsapi=1&showinfo=0&rel=0'
      );
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('class', 'youtube-iframe');
      v.firstChild.replaceWith(iframe);
    }



    // Wrap iFrames
    $('[class^="module-"] iframe:not([id^="gform_ajax"])').wrap('<div class="responsive-embed">');

    $('.entry-content iframe.wp-embedded-content').wrap('<div class="responsive-embed-post">');

    // Filter technologies
    // $('.filter-btn').click(function(){
    //   $('.filter-btn').removeClass('active');
    //   var type = $(this).data('filter');
    //   $(this).addClass('active');
    //   $('.filter-cells .filter-cell').hide();
    //   $('.filter-cells .filter-cell[data-type*="' + type + '"]').show();
    // });
    //
    // $('.clear-filter').click(function(){
    //   $('.filter-btn').removeClass('active');
    //   $('.filter-cells .filter-cell').show();
    // });

    /* eslint-disable */
    (function( $ ) {
      $.fn.slickFilterable = function( options ) {

        /**
         * A plugin to create a slick we can filter.
         *
         * If you are not using Rows you can use slickFilter
         * (check documentation) otherwise we can provide a valid filter.
         *
         * options {
         *      slideSelector    string     jQuery selector to get slides. Imetiate children by default.
         *      filterName       string     We will search for data-{filterName} clickable elements.
         *      slick            object     The slick settings. Check Slick doc.
         *      beforeFilter     function   A fuction called before filter slider. Receives the trigger element
         *                                  as this and 3 params: category (string), slider and slides (jQuery objects).
         *      filter           mix        A valid parameter to jQuery filter() function. If it's a functio we will wrap
         *                                  it and it receives the trigger element as this and 3 params: category (string),
         *                                  slider (jQuery object) and a copy of settings (extended).
         * }
         */
        var settings = $.extend({
          slideSelector: '> *',
          filterName: 'filter-slick',
          slick: {},
          beforeFilter: function() {},
          filter: function( element, category, slider, settings ) { return true; },
        }, options );

        return this.each(function() {
          var slider = $(this),
            slides = slider.find( settings.slideSelector ),
            slickObj;

          /**
           * Create Slick
           *
           * TIP: you should you 'slidesPerRow' instead 'slidesToShow' in grid mode (with rows)
           * to avoid slick break layout when there are less slides than on "page".
           */
          slickObj = slider.slick( settings.slick );

          // Handle Filter Click
          $('[data-' + settings.filterName + ']').on('click', function(event) {
            event.preventDefault();

            $('.filter-btn').removeClass('active');
            $(this).addClass('active');
            var category = $(this).data(settings.filterName),
              newSlides = $.extend(true, {}, slides),
              newSlickOptions;

            if ( ! category ) return;

            // Before Filter Slides
            if ( typeof settings.beforeFilter == 'function' ) {
              settings.beforeFilter.call(this, category, slider, slides);
            }

            // Destroy and empty
            slider.slick('unslick');

            // Recreate All Slides
            if ( category === 'all' ) {
              slider.find( settings.slideSelector ).remove();
              slider.append( newSlides );
              slider.slick( settings.slick );
              $('.filter-btn').removeClass('active');
              return;
            }

            /**
             * Filter Slides
             *
             * If settings.filter is a function we pass the category, slider and a copy of settings
             * expecting a true or false return to pass it to jQuery.filter();
             *
             * If not, we just pass it directly.
             */
            if ( typeof settings.filter !== 'function' ) {
              newSlides = newSlides.filter( settings.filter );
            } else {
              newSlides = newSlides.filter( function() {
                return settings.filter.call( this, category, slider, $.extend( true, {}, settings ) );
              } );
            }

            slider.find( settings.slideSelector ).remove();
            slider.append( newSlides );
            slider.slick( settings.slick );
          });
        });
      };
    }(jQuery));


    $('.filter-carousel').slickFilterable({
      filterName: 'filter',
      filter: function( category, slider, settings ) {
        return $(this).hasClass( category );
      },
      slick: {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        rows: 3,
        slidesToScroll: 2,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              rows: 3,
              slidesToScroll: 1,
            },
          },
        ],
      },
    });

    /* eslint-enable */


    // $('.filter-btn').on('click', function(){
    //     $('.filter-btn').removeClass('active');
    //      var type = $(this).data('filter');
    //       $(this).addClass('active');
    //       console.log(type);
    //       $('.filter-cells').slick('slickFilter', '.filter-cell[data-type*="' + type + '"]');
    // });
    //
    //   $('.clear-filter').on('click', function() {
    //     $('.filter-btn').removeClass('active');
    //     $('.filter-cells').slick('slickUnfilter');
    //   });







    // Carousels

    if ($(window).width() < 768) {
      $('.module-projects_feed .project-blank, .module-carousel_history .slide-blank').appendTo('.not-on-mobile');
    }

    $(window).resize(function () {
      if ($(window).width() < 768) {
        $('.module-projects_feed .project-blank, .module-carousel_history .slide-blank').appendTo('.not-on-mobile');
      } else {
        $('.module-projects_feed .project-blank, .module-carousel_history .slide-blank').appendTo('.projects-feed-image-carousel');
      }
    });


    $('.logo-grid-carousel').slick({
      dots: false,
      arrows: false,
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
    });


    $('.projects-feed-image-carousel').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.history-carousel').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.content-feed-carousel').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.logos-grid-carousel').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      rows: 2,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            rows: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });


    $('.shop-carousel').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      autoplay: true,
    });

    $('.testimonials-carousel').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });



    generateFuzz();
    $('.word-slide').shuffleLetters();
    $('.fuzzyoff').slick({
      arrows: false,
      dots: false,
      speed: 350,
      infinite: true,
      draggable: false,
      fade: true,
      slidesToShow:1,
      autoplay: true,
      variableHeight: true,
    });
    $('.fuzzyoff')
      .on('init', function() {
        $('.word-slide:first-of-type').shuffleLetters();
      })
      .on('beforeChange', function() {
        $('.word-slide').shuffleLetters();
        setTimeout(function(){
          generateFuzz();
        }, 100);

        setTimeout(function(){
          $('.word-slide').css('opacity',0);
        }, 200);

      })
    .on('afterChange', function() {

      $('.word-slide').css('opacity',1);

      });


    function randomIntFromInterval(min, max) { // min and max included
      return Math.floor(Math.random() * (max - min + 1) + min)
    }


    var colors = ['#00A6C4','#F02070','#34B589','#FFFFFF', '#000000','#00A6C4','#F02070','#34B589' ];
    function getColorRandomly() {
      return colors[Math.floor(Math.random() * colors.length)];
    }

    function generateFuzz() {


      // const someRandom = () => Math.floor(Math.random() * 101);
      // const randomColor = () => `#${Math.floor(Math.random()*16777215).toString(16)}`;
      var i = 0;

      for (i = 0; i <= 8; i++) {
        const rndInt = randomIntFromInterval(10, 110);
        const rndIntO = randomIntFromInterval(60, 99);
        const rndIntHeight = randomIntFromInterval(1, 32);
        const rndIntRollIn = randomIntFromInterval(1, 300);
        const rndIntTop = randomIntFromInterval(1, 90);
        const rndIntLeft = randomIntFromInterval(0,100);
        const modifier = randomIntFromInterval(1, 10) * i;
        setTimeout(function(){
          $('<div class="fuzz"></div>').appendTo('.word-transition').css({
            'top': rndIntTop + 'px',
            'left': rndIntLeft + 'px',
            'width': rndInt * 5 + 'px',
            'height': rndIntHeight + 'px',
            'background-color': getColorRandomly(),
            'opacity': '0.' + rndIntO,
            'z-index': rndInt,
          });
        }, rndIntRollIn);
        setTimeout(function(){
          $('<div class="blackout"></div>').appendTo('.word-transition').css({
            'top': rndIntTop * modifier + 'px',
            'left': (rndIntLeft * modifier) + 'px',
            'width': modifier + 'px',
            'height': (rndIntHeight * modifier) + 'px',
            'background-color': 'black',
            'z-index': modifier + rndInt,
          });
        }, rndIntRollIn - 100);

      }

      for(i = 1; i <= 6; i++) {
        blink('.fuzz', -1, 300);
      }


      setTimeout(function(){
        $('.fuzz').remove();
      }, 550);

      setTimeout(function(){
        $('.blackout').remove();
      }, 350);


    }


    function blink(elem, times, speed) {
      if (times > 0 || times < 0) {
        if ($(elem).hasClass('blink'))
          $(elem).removeClass('blink');
        else
          $(elem).addClass('blink');
      }

      clearTimeout(function() {
        blink(elem, times, speed);
      });

      if (times > 0 || times < 0) {
        setTimeout(function() {
          blink(elem, times, speed);
        }, speed);
        times -= .5;
      }
    }

    $('.checklist > p').each(function() {
      $(this).remove();
    });

    (function($) {
      $(document).on('facetwp-loaded', function() {
        var qs = FWP.buildQueryString();  // eslint-disable-line
        if ( '' === qs ) { // no facets are selected
          $('.reset-filters').hide();
        }
        else {
          $('.reset-filters').show();
        }
      });
    })(jQuery);



    $('.mobile-nav-trigger').click(function(){
      $('.mobile-nav').show();
    });

    $('.close-nav-trigger').click(function(){
      $('.mobile-nav').hide();
    });


    $('.mobile-navigation .menu-item-has-children > a').click(function (e) {
      e.preventDefault();
      //

     if($(this).hasClass('active-parent') ) {
        $(this).removeClass('active-parent');
      } else {
       $('.mobile-navigation .menu-item-has-children > a').removeClass('active-parent');
        $(this).addClass('active-parent');
      }


    });


    $('.mobile-navigation .btn-cta a').appendTo('.mobile-nav').addClass('button hollow mobile-nav-callout-btn');




    /*
 * Replace all SVG images with an SVG Object
 */
    jQuery('img:not(.objectfallback, .table-check, .emoji)').filter(function() {
      return this.src.match(/.*\.svg$/);
    }).each(function(){
      var $img = jQuery(this);
      // var imgID = $img.attr('id');
      var imgAlt = $img.attr('alt');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      jQuery.get(imgURL, function() {
        // Get the SVG tag, ignore the rest
        var $svg = '<object type="image/svg+xml" class="svgObject '+ imgClass +'" data="'+ imgURL +'"><img src="'+ imgURL +'" alt="'+ imgAlt+'"></object>'

        // Replace image with new SVG
        $img.replaceWith($svg);

        $img = null;
      }, 'xml');

    });


    $('.project-callout a, .content-callout a').addClass('softbutton white');



    setTimeout(function() {
      // console.log(jQuery('.hs-form-booleancheckbox-display').val());
      // jQuery('.newsletter .hs-form-booleancheckbox-display').click();
      // jQuery('.newsletter #content_hub_subscription-fc9ed2b2-d53b-4b5a-971a-e2149a7cf2a8').click();
      //
      // jQuery('.subscribe-overlay-form .hs-form-booleancheckbox-display').click();
      // jQuery('.subscribe-overlay-form #content_hub_subscription-fc9ed2b2-d53b-4b5a-971a-e2149a7cf2a8').click();

      // jQuery('.subscribe-overlay-form .hs_content_hub_subscription').hide();

    }, 1000);



    // Move Woo Category Filter before the ordering dropdown

    if($('.category-filter')) {

      $('.category-filter').insertBefore('.woocommerce-ordering');
      $('.category-filter, .woocommerce-ordering').wrapAll('<div class="shop-filtering"></div>');


    }


    /*
     * Services scroll module
     */
    function servicesScroll() {
      var desktopMq = window.matchMedia ? window.matchMedia('(min-width: 1180px)') : { matches: false };

      $('[data-services-scroll]').each(function() {
        var module = this;
        var track = module.querySelector('[data-services-scroll-track]');
        var items = $.makeArray(module.querySelectorAll('[data-services-scroll-item]'));
        var bodies = $.makeArray(module.querySelectorAll('.services-scroll__body-inner'));
        var markers = $.makeArray(module.querySelectorAll('[data-services-scroll-marker]'));
        var segment = 0;
        var ticking = false;

        if (!track || !items.length || !markers.length || $(module).data('servicesScrollInitialized')) {
          return;
        }

        $(module).data('servicesScrollInitialized', true);

        function markerHeight() {
          return Math.max(Math.round(window.innerHeight * 0.86), 640);
        }

        function clamp(value, min, max) {
          return Math.min(Math.max(value, min), max);
        }

        function measureItems() {
          segment = markerHeight();

          bodies.forEach(function(body, bodyIndex) {
            if (items[bodyIndex]) {
              items[bodyIndex].servicesScrollHeight = body.scrollHeight;
            }
          });

          track.style.minHeight = (window.innerHeight + (segment * Math.max(items.length - 1, 0))) + 'px';

          markers.forEach(function(marker, markerIndex) {
            marker.style.height = (markerIndex === 0 ? window.innerHeight : segment) + 'px';
          });
        }

        function updateState() {
          if (!desktopMq.matches) {
            $(module).removeClass('is-enhanced');
            items.forEach(function(item) {
              $(item).removeClass('is-open');
              item.style.setProperty('--open', 1);
              item.style.setProperty('--open-height', 'none');
            });
            ticking = false;
            return;
          }

          $(module).addClass('is-enhanced');

          var rect = track.getBoundingClientRect();
          var progress = clamp(-rect.top / Math.max(segment, 1), 0, Math.max(items.length - 1, 0));

          items.forEach(function(item, itemIndex) {
            var open = clamp(1 - Math.abs(progress - itemIndex), 0, 1);
            var itemHeight = parseFloat(item.servicesScrollHeight || 0);

            $(item).toggleClass('is-open', open > 0.01);
            item.style.setProperty('--open', open.toFixed(4));
            item.style.setProperty('--open-height', Math.round(itemHeight * open) + 'px');
          });

          ticking = false;
        }

        function requestUpdate() {
          if (!ticking) {
            ticking = true;
            (window.requestAnimationFrame || function(callback) {
              return window.setTimeout(callback, 16);
            })(updateState);
          }
        }

        if (desktopMq.matches) {
          $(module).addClass('is-enhanced');
        }

        measureItems();
        requestUpdate();

        window.addEventListener('scroll', requestUpdate, { passive: true });

        window.addEventListener('resize', function() {
          measureItems();
          requestUpdate();
        });

        if (typeof desktopMq.addEventListener === 'function') {
          desktopMq.addEventListener('change', function() {
            measureItems();
            requestUpdate();
          });
        } else if (typeof desktopMq.addListener === 'function') {
          desktopMq.addListener(function() {
            measureItems();
            requestUpdate();
          });
        }
      });
    }

    if ($('[data-services-scroll]').length) {
      servicesScroll();
    }



    /*
     * Tabbed Content functionality
     */
    function tabbedContent() {

      $('.module-tabbed_content').each(function() {
        var $module = $(this);
        var $buttons = $module.find('.tab-button');
        var $panels = $module.find('.tab-panel');

        $buttons.first()[0].style.setProperty('--tab-color', $buttons.first().data('color'));

        $buttons.on('mouseover', function() {
          var $button = $(this);
          $button[0].style.setProperty('--tab-color', $button.data('color'));
        });

        $buttons.on('mouseout', function() {
          var $button = $(this);
          if (!$button.hasClass('active')) {
            $button[0].style.setProperty('--tab-color', 'white');
          }
        });

        $buttons.on('click', function() {
          var $button = $(this);
          var targetTab = $button.data('tab');
          var $targetPanel = $module.find('#' + targetTab);

          // Remove active class from all buttons and panels
          $buttons.removeClass('active');
          $buttons.each(function() {
            this.style.setProperty('--tab-color', 'white');
          });
          $panels.removeClass('active');

          // Add active class to clicked button and corresponding panel
          $button.addClass('active');
          $button[0].style.setProperty('--tab-color', $button.data('color'));
          $targetPanel.addClass('active');
        });
      });
    }

    // Initialize tabbed content
    if ($('.module-tabbed_content').length) {
      tabbedContent();
    }

    /*
     * Tabs functionality
     */
    function tabsModule() {
      $('.module-tabs').each(function() {
        var $module = $(this);
        var $buttons = $module.find('.tab-button');
        var $panels = $module.find('.tab-panel');

        $buttons.on('click', function(e) {
          e.preventDefault();
          var $button = $(this);
          var targetTab = $button.data('tab');
          var $targetPanel = $module.find('#' + targetTab);

          if ($button.hasClass('active')) {
            return;
          }

          $buttons.removeClass('active');
          $panels.removeClass('active');

          $button.addClass('active');
          $targetPanel.addClass('active');
        });
      });
    }

    // Initialize tabs module
    if ($('.module-tabs').length) {
      tabsModule();
    }



  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js